/**
 * @author mi
 * @date 2019/7/24
 * @project zujuanzaixian
 */
export function hasPaperData (typeCompose) {
  return _.max(_.map(typeCompose, (item) => item.sub.length)) > 0
}
